import React from 'react';
import PropTypes from 'prop-types';
import BodyClassName from 'react-body-classname';
import CSSTransition from 'react-transition-group/CSSTransition';
import CoreModal from '@sparefoot/react-core/Modal';
import classnames from 'classnames';

import './Modal.scss';

export default function Modal({
	showing,
	hasDarkTitleBackground = false,
	...rest
}) {
	return (
		<BodyClassName
			className={classnames({
				'no-scroll': showing,
			})}
		>
			<CSSTransition
				classNames="transition-fade-in"
				in={showing}
				unmountOnExit
				timeout={150}
			>
				<CoreModal
					{...rest}
					className={classnames(rest.className, 'ss-modal', {
						'dark-title-bg': hasDarkTitleBackground,
						'light-title-bg': !hasDarkTitleBackground,
					})}
				/>
			</CSSTransition>
		</BodyClassName>
	);
}

Modal.propTypes = {
	className: PropTypes.string,
	showing: PropTypes.bool,
	hasDarkTitleBackground: PropTypes.bool,
};
